import { apiFetch } from '@lib/api/apiClient';

export async function registerNotice(formData) {
    const res = await apiFetch('/notice/register', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });

    if (!res.ok) {
        throw new Error('공지사항 정보 저장에 실패하였습니다.');
    }
    return (await res.json()).data;
}

export async function modifyNotice(formData) {
    const res = await apiFetch('/notice/modify', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });
    if (!res.ok) {
        throw new Error('공지사항 정보 수정에 실패하였습니다.');
    }
    return (await res.json()).data;
}

export async function modifyNoticeStatus(formData) {
    const res = await apiFetch('/notice/status/modify', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });
    if (!res.ok) {
        throw new Error('공지사항 상태 변경 실패하였습니다.');
    }
    return (await res.json()).data;
}

/**
 * @param {any} searchParam
 */
export async function getNotice(searchParam) {
    const res = await apiFetch(`/notice/list`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(searchParam)
    });

    if (!res.ok) {
        throw new Error('공지사항 목록을 불러오지 못했습니다.');
    }

    return (await res.json()).data;
}